import { useEffect, useRef, useState } from 'react'
import {
  SActionBtn,
  SDrawerOrModal,
  SGeneralForms,
  SLowcodeList,
  SMessage,
  STableActions,
} from 'shj-components'
import { config } from './config'
import {
  materialDescriptionDelete,
  getGeneralList,
  getProductCommonPage,
  getProductEnums,
  getProjectPage,
  getSpuPageList,
  materialDescriptionImport,
  materialDescriptionPage,
  projectDelete,
  projectSave,
  projectUpdateById,
  projectUpdateState,
  materialDescriptionAdd,
  materialDescriptionUpdate,
} from '@/services/product.ts'
import { apiData2Table, trimStr } from '@/utils/data.ts'
import { Button, message, Select, Spin, Switch, Upload } from 'antd'
import { isEmpty } from 'lodash-es'
import { useSetState } from 'ahooks'
import DebounceSelect from '@/pages/baseProduct/components/DebounceSearchSelect'
import { httpOrgList } from '@/services/homeService'
import _ from 'lodash'
import UrlConfig from '@/api/UrlConfigs'
import { fileDownload } from '@/utils/download'
import dayjs from 'dayjs'
import DebounceSearchSelect from '@/pages/baseProduct/components/DebounceSearchSelect'

export default function MaterialDescription() {
  const listRef = useRef()
  const formRef = useRef<any>()
  const [open, setOpen] = useState(false)
  const [record, setRecord] = useState<any>({})
  const [btnLoading, setBtnLoading] = useState(false)
  const [importLoading, setImportLoading] = useState(false)
  const [exportLoading, setExportLoading] = useState(false)
  const [downloadLoading, setDownloadLoading] = useState(false)
  const [optionList, setOptionList] = useState<any>([])

  const [state, setState] = useSetState<any>({
    loading: false,
  })

  const fetchList = values => {
    const { current, pageSize, ...rest } = values
    return new Promise((resolve, reject) => {
      materialDescriptionPage({
        params: { pageId: current, pageSize },
        data: rest.query,
      })
        .then(res => {
          resolve(apiData2Table(res))
        })
        .catch(reject)
    })
  }
  const onAdd = () => onEdit()
  const onEdit = (record = {}) => {
    setOpen(true)
    setRecord({ ...record })
  }
  const onFormRef = () => {
    const { onFormRef } = formRef.current || {}
    return onFormRef?.()
  }

  useEffect(() => {
    if (!isEmpty(record)) {
      const obj = {
        ...record,
        startDate: dayjs(record.startDate),
        endDate: record.endDate && dayjs(record.endDate),
      }
      onFormRef()?.setFieldsValue({ ...obj })
    } else {
      return () => {
        onFormRef()?.resetFields()
      }
    }
  }, [record])

  //  表格事件: 删除
  const onDel = id => {
    SMessage.confirm({
      onOk: () => {
        return materialDescriptionDelete(id).then((res: any) => {
          message.success(res.message || '操作成功')
          listRef.current?.reload()
        })
      },
    })
  }

  const onSubmit = () => {
    onFormRef()
      ?.validateFields()
      .then(values => {
        setBtnLoading(true)
        const apiUrl = values.id ? materialDescriptionUpdate : materialDescriptionAdd
        const obj = {
          ...values,
          startDate: values.startDate && dayjs(values.startDate).format('YYYY-MM-DD'),
          endDate: values.endDate && dayjs(values.endDate).format('YYYY-MM-DD'),
        }

        apiUrl({ data: { ...obj } })
          .then((res: any) => {
            message.success(res.message || '操作成功')
            listRef.current?.reload()
            setOpen(false)
          })
          .finally(() => setBtnLoading(false))
      })
  }

  // 下载模版
  const downloadTemplate = () => {
    setDownloadLoading(true)
    fileDownload(UrlConfig.PlusProductWeb.MaterialDescriptionTemplate, {
      method: 'GET',
    })
      .then(() => setDownloadLoading(false))
      .catch(() => setDownloadLoading(false))
  }

  // 批量导入
  const batchImport = (upload: any) => {
    setImportLoading(true)
    const { file, onSuccess, onError } = upload
    const data = new FormData()
    data.append('file', file)
    return materialDescriptionImport({ data })
      .then((res: any) => {
        listRef.current?.reload()
        onSuccess && onSuccess()
        message.success(res.message || '导入成功')
      })
      .catch(onError)
      .finally(() => setImportLoading(false))
  }

  // 导出
  const exportTemplate = () => {
    setExportLoading(true)
    fileDownload(UrlConfig.PlusProductWeb.MaterialDescriptionExport, {
      method: 'POST',
    })
      .then(() => setExportLoading(false))
      .catch(() => setExportLoading(false))
  }
  const getOptions = async () => {
    setState({ loading: true })
    try {
      const generalList = await getGeneralList({ enabled: true })
      const companyList: any = await httpOrgList()
      setState({
        generalList,
        loading: false,
      })
      setOptionList([{ id: '0', name: '通用' }, ...companyList])
      return Promise.resolve({
        generalList,
        radioList: [
          {
            label: '通项',
            value: 'GENERAL',
          },
          {
            label: '产品',
            value: 'PRODUCT',
          },
        ],
      })
    } catch (e) {
      setState({ loading: false })
    }
  }

  const shopsControl = (value: any) => {
    let newOption: any = _.cloneDeep(optionList)
    if (value?.length) {
      if (value.includes('0')) {
        newOption = newOption.map((item: any) => {
          return {
            ...item,
            disabled: item.id !== '0',
          }
        })
      } else {
        newOption = newOption.map((item: any) => {
          return {
            ...item,
            disabled: item.id === '0',
          }
        })
      }
    } else {
      newOption = newOption.map((item: any) => {
        return {
          ...item,
          disabled: false,
        }
      })
    }
    setOptionList(newOption)
  }
  const getStatusOptions = async () => {
    const companyList: any = await httpOrgList()
    return Promise.resolve({
      companyList: [{ name: '通用', id: '0' }, ...companyList],
    })
  }
  const extensions = {
    request: { fetchList, getStatusOptions },
    events: {
      onAdd,
    },
    status: {
      selectedDisabled: ({ selectedRowKeys }: any) => !selectedRowKeys.length,
      radioDisabled: ({ selectedRowKeys }: any) => selectedRowKeys.length !== 1,
    },
    customRender: {
      typeRender(_, record: Record<string, any>) {
        return record.itemType === 'GENERAL' ? '通项' : '产品'
      },
      optionCell(_, record: Record<string, any>) {
        return (
          <STableActions>
            <SActionBtn onClick={() => onEdit(record)}>编辑</SActionBtn>
            <SActionBtn danger onClick={() => onDel(record.id)}>
              删除
            </SActionBtn>
          </STableActions>
        )
      },
      // 下载导入模版
      downloadRender() {
        return (
          <Button onClick={() => downloadTemplate()} loading={downloadLoading}>
            下载导入模板
          </Button>
        )
      },
      // 批量导入
      importRender() {
        return (
          <Upload listType="text" customRequest={batchImport} itemRender={() => null}>
            <Button type="primary" loading={importLoading}>
              批量导入
            </Button>
          </Upload>
        )
      },
      // 导出
      exportRender() {
        return (
          <Button onClick={() => exportTemplate()} loading={exportLoading}>
            导出
          </Button>
        )
      },
      searchSelectRender({ name, form }) {
        return (
          <DebounceSearchSelect
            allowClear
            label={'产品'}
            isCommon={true}
            fetchOptions={getProductCommonPage}
               fixedParams={{
              prodTypes: [ 'PRODUCT_PACKAGE'],
            }}
            onChange={v => form.setFieldsValue({ [name]: v })}
            fieldNames={{ label: 'prodName' }}
            style={{ width: '100%' }}
          />
        )
      },
    },
  }

  return (
    <div>
      <SLowcodeList ref={listRef} searchMode="group" config={config} {...extensions} />
      <SDrawerOrModal
        title={(record.id ? '编辑' : '新增') + '配置'}
        mode="drawer"
        open={open}
        loading={btnLoading}
        onCancel={() => setOpen(false)}
        onOk={onSubmit}
        width={500}
      >
        <Spin spinning={state.loading}>
          {open && (
            <SGeneralForms
              ref={formRef}
              layout={'vertical'}
              initialValues={{ itemType: 'GENERAL' }}
              httpOptionsFn={getOptions}
              configs={[
                {
                  formItem: [
                    { label: 'id', name: 'id', hidden: true },
                    {
                      label: '类型',
                      name: 'itemType',
                      spanCol: 24,
                      type: 'radio',
                      data: 'radioList',
                      comConfig: {
                        onChange: (e: any) => {
                          onFormRef()?.resetFields(['itemId'])
                        },
                      },
                    },
                    {
                      name: 'itemId',
                      label: '通项',
                      required: true,
                      isDeps: true,
                      deps: form => form.getFieldValue('itemType') === 'GENERAL',
                      rules: [{ required: true, message: '通项不能为空' }],
                      spanCol: 24,
                      data: 'generalList',
                      type: 'select',
                      comConfig: {
                        fieldNames: { label: 'itemName', value: 'id' },
                      },
                    },
                    {
                      name: 'itemId',
                      label: '产品SPU',
                      isDeps: true,
                      required: true,
                      deps: form => form.getFieldValue('itemType') === 'PRODUCT',
                      // required: !props.readOnly,
                      rules: [{ required: true, message: '产品SKU不能为空' }],
                      spanCol: 24,
                      children: (
                        <DebounceSearchSelect
                          fetchOptions={getSpuPageList}
                          label={'产品SPU'}
                          nameKey={'keyword'}
                          fixedParams={{
                            prodTypes: ['PRODUCT_SINGLE', 'PRODUCT_GROUP', 'PRODUCT_BASIC_ITEM'],
                          }}
                          fieldNames={{ label: 'prodName', value: 'id' }}
                          query={{ id: record?.itemId }}
                        />
                      //   <DebounceSearchSelect
                      //   readOnly={props.readOnly}
                      //   fetchOptions={getSkuPageList}
                      //   label={'产品SKU'}
                      //   nameKey={'keyword'}
                      //   disabled={props.record?.id}
                      //   fixedParams={{
                      //     prodTypes: ['PRODUCT_SINGLE', 'PRODUCT_GROUP', 'PRODUCT_BASIC_ITEM'],
                      //   }}
                      //   fieldNames={{ label: 'showName', value: 'id' }}
                      //   query={{ id: state.initValues.productSkuId }}
                      // />
                      ),
                    },
                    {
                      label: '工艺及材料说明',
                      name: 'description',
                      spanCol: 24,
                      type: 'textarea',
                      required: true,
                      rules: [{ required: true, message: '工艺及材料说明不能为空' }],
                      comConfig: {
                        maxLength: 500,
                        showCount: true,
                      },
                    },
                    {
                      spanCol: 24,
                      label: '适用产品',
                      name: record.id ? 'applyProdId' : 'applyProdIds',
                      required: true,
                      rules: [{ required: true, message: '适用产品不能为空' }],
                      children: (
                        <DebounceSelect
                          allowClear
                          label={'产品'}
                          isCommon={true}
                          mode={'multiple'}
                          fixedParams={{ prodTypes: ['PRODUCT_PACKAGE'] }}
                          fetchOptions={getProductCommonPage}
                          fieldNames={{ label: 'prodName', value: 'id' }}
                          disabled={record.id}
                          query={{ id: record?.applyProdId }}
                        />
                      ),
                    },
                    {
                      name: record.id ? 'orgId' : 'orgIds',
                      label: '适用门店',
                      required: true,
                      spanCol: 24,
                      children: (
                        <Select
                          optionFilterProp={'name'}
                          placeholder={'请选择适用门店'}
                          mode={'multiple'}
                          fieldNames={{ label: 'name', value: 'id' }}
                          onChange={(value, option) => {
                            shopsControl(value)
                          }}
                          options={optionList}
                          disabled={record.id}
                        />
                      ),
                    },
                    {
                      spanCol: 24,
                      label: '开始日期',
                      name: 'startDate',
                      required: true,
                      rules: [{ required: true, message: '开始日期不能为空' }],
                      type: 'date',
                    },
                    {
                      spanCol: 24,
                      label: '结束日期',
                      name: 'endDate',
                      type: 'date',
                      comConfig: {
                        disabledDate: current => {
                          const startDate = onFormRef().getFieldValue('startDate')
                          if (startDate) return current && current < dayjs(startDate).endOf('day')
                        },
                      },
                    },
                  ],
                },
              ]}
            />
          )}
        </Spin>
      </SDrawerOrModal>
    </div>
  )
}
